import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-page-title',
  template: ` <h1 class="page-title">{{ title }}</h1> `,
  styles: [
    `
      .page-title {
        margin: 1rem 0;
        font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-600)
          var(--unnamed-font-size-30) / var(--unnamed-line-spacing-41)
          var(--unnamed-font-family-open-sans);
        letter-spacing: var(--unnamed-character-spacing-0);
        color: var(--darkest-gray);
        text-align: left;
        font: normal normal 600 30px/41px Open Sans;
        letter-spacing: 0px;
        color: #444444;
        opacity: 1;
      }
    `,
  ],
})
export class PageTitleComponent {
  @Input() title: string;
}
